var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 12,
    r: 0,
    transform: "translate(8 0)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: 0,
    calcMode: "spline",
    dur: "1.2s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8",
    keyTimes: "0;0.2;0.7;1",
    repeatCount: "indefinite",
    values: "0; 4; 0; 0"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 12,
    r: 0,
    transform: "translate(16 0)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: 0.3,
    calcMode: "spline",
    dur: "1.2s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8",
    keyTimes: "0;0.2;0.7;1",
    repeatCount: "indefinite",
    values: "0; 4; 0; 0"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 12,
    r: 0,
    transform: "translate(24 0)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: 0.6,
    calcMode: "spline",
    dur: "1.2s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8",
    keyTimes: "0;0.2;0.7;1",
    repeatCount: "indefinite",
    values: "0; 4; 0; 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderDots);
export default __webpack_public_path__ + "static/media/loader-dots.450e514e79d99453e6e492ea7645c3f0.svg";
export { ForwardRef as ReactComponent };